/** Espelha ATS.Hub.API.Vendas.Enums.ModoAoVencerAutomacaoVendaEnum. */
export enum ModoAoVencerAutomacaoVendaEnum {
  ExecutarAutomaticamente = 1,
  ApenasNotificar = 2,
}
